import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Contract } from "@edp-components/edp-contract/edp-contract.model";
import { EdpModalService } from "@edp-components/edp-modal";
import { SCREEN_SIZES } from "@edp-enums/screen-sizes.enum";
import { TooltipModalComponent } from "@edp-pages/contract-consumption-local/contract-define-house-v2/components/tooltip-modal/tooltip-modal.component";
import { ContractDefineHouseV2Service } from "@edp-services/contract-define-house-v2.service";
import { DatalayerService } from "@edp-services/datalayer.service";
import { EdpDefineHouseTermsConditionsService } from "@edp-services/edp-define-house-terms-conditions.service";
import { GetServiceAnswers, SetHouseStatusMoonShot } from "@edp-store/actions/define-house.action";
import { ShowLoader } from "@edp-store/actions/layout.actions";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "edp-define-house-terms-conditions",
    templateUrl: "./edp-define-house-terms-conditions.component.html",
    styleUrls: ["./edp-define-house-terms-conditions.component.scss"],
})
export class EdpDefineHouseTermsConditionsComponent implements OnInit {
    selectedContract: Contract;
    acceptTerms = false;
    mobileSize = false;
    templateKeyHTML = "pt.edp.edponline.house.terms.conditions.terms.tooltip";

    constructor(
        private readonly store: Store<IAppState>,
        private readonly router: Router,
        private readonly edpDefineHouseTermsConditionsService: EdpDefineHouseTermsConditionsService,
        private edpModalService: EdpModalService,
        private readonly translateService: TranslateService,
        private contractDefineHouseService: ContractDefineHouseV2Service,
        private datalayerService: DatalayerService
    ) {
        this.store.pipe(select(getContract)).subscribe((contract: Contract) => {
            if (!!contract) {
                this.selectedContract = contract;
            }
        });
    }

    ngOnInit(): void {
        this.onResize();
        this.datalayerService.setGaEvent("modalView", {
            formType: "Informacao",
            formModal: "PrimeiraAberturaCaracterizacao",
        });
    }

    @HostListener("window:resize")
    public onResize() {
        this.mobileSize = window.innerWidth < SCREEN_SIZES.WDGT;
    }

    goToMoonShot() {
        this.datalayerService.setGaClick("termsAndConditionsTrue");
        const args = {
            account: this.selectedContract.AccountNumber,
            termsAndConditions: true,
            events: [
                {
                    event: "start_dialogue",
                },
            ],
        };

        this.contractDefineHouseService.postContractDefineData(args).subscribe(
            res => {
                this.store.dispatch(new ShowLoader(false));
                const statusMoonshot = {
                    started: true,
                    completed: false,
                    fullElectric: false,
                };

                this.store.dispatch(new SetHouseStatusMoonShot(statusMoonshot));
                this.store.dispatch(new GetServiceAnswers());
                this.edpDefineHouseTermsConditionsService.hideTermsConditionsModal();
                this.router.navigate([`/locais-consumo/${this.selectedContract.ContractId}/casa/alteracao/beta/casa`], {
                    state: { bypassGuard: true },
                });
            },
            error => {
                this.store.dispatch(new ShowLoader(false));
                console.error(error);
            }
        );
    }

    closeTermsConditions() {
        this.edpDefineHouseTermsConditionsService.hideTermsConditionsModal();
        this.datalayerService.setGaClick("clickClose", {
            interactionName: "fechar",
            interactionLocation: "PrimeiraAberturaCaracterizacao",
        });
    }

    toggleAcceptTerms(event: any) {
        this.acceptTerms = event.target.checked;
    }

    openTooltipModal(): void {
        const modalOptions: NgbModalOptions = {
            windowClass: "edp-modal-window edp-modal-tooltip",
            size: "lg",
        };

        const modalData = {
            messageHTML: this.translateService.instant(this.templateKeyHTML),
            showClose: true as boolean,
        };

        this.edpModalService.custom(TooltipModalComponent, modalOptions, modalData);
    }
}
